// Evan Ventura Photography - Site Configuration
// Edit this file to update your website content

export const siteConfig = {
  // Photographer Information
  photographer: {
    name: "Evan Ventura",
    title: "Professional Photographer",
    bio: "I'm a passionate photographer with over a decade of experience capturing life's most precious moments. My journey began with a simple love for storytelling through images, and has evolved into a career dedicated to creating timeless photographs that families treasure for generations.",
    location: "Downtown Photography Studio, City, State 12345",
    experience: "10+",
    clients: "500+",
    weddings: "50+",
    photos: "1000+"
  },

  // Contact Information
  contact: {
    email: "evan@evanvent-photography.com",
    phone: "(123) 456-7890",
    address: "Downtown Photography Studio, City, State 12345",
    businessHours: "Mon-Fri: 9AM-6PM, Sat: 10AM-4PM, Sun: Closed"
  },

  // Social Media Links
  social: {
    instagram: "https://instagram.com/evanventura",
    facebook: "https://facebook.com/evanventura",
    twitter: "https://twitter.com/evanventura"
  },

  // Services
  services: [
    {
      title: "Portrait Photography",
      description: "Professional headshots, family portraits, and creative portraits that capture your unique personality.",
      icon: "camera"
    },
    {
      title: "Wedding Photography", 
      description: "Beautiful wedding photography that tells your love story with artistic vision and attention to detail.",
      icon: "heart"
    },
    {
      title: "Commercial Photography",
      description: "High-quality product and commercial photography to elevate your brand and marketing materials.",
      icon: "star"
    }
  ],

  // Portfolio Images - Replace these URLs with your actual photo URLs
  portfolio: {
    categories: [
      {
        id: "all",
        name: "All"
      },
      {
        id: "portraits", 
        name: "Portraits"
      },
      {
        id: "weddings",
        name: "Weddings"
      },
      {
        id: "commercial",
        name: "Commercial"
      },
      {
        id: "events",
        name: "Events"
      }
    ],
    images: [
      {
        id: 1,
        src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",
        alt: "Professional Portrait",
        category: "portraits",
        title: "Professional Portrait"
      },
      {
        id: 2,
        src: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
        alt: "Wedding Ceremony",
        category: "weddings",
        title: "Wedding Ceremony"
      },
      {
        id: 3,
        src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1026&q=80",
        alt: "Product Photography",
        category: "commercial",
        title: "Product Photography"
      },
      {
        id: 4,
        src: "https://images.unsplash.com/photo-1513151233558-d860c5398176?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
        alt: "Corporate Event",
        category: "events",
        title: "Corporate Event"
      },
      {
        id: 5,
        src: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",
        alt: "Business Portrait",
        category: "portraits",
        title: "Business Portrait"
      },
      {
        id: 6,
        src: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
        alt: "Wedding Reception",
        category: "weddings",
        title: "Wedding Reception"
      },
      {
        id: 7,
        src: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
        alt: "Fashion Photography",
        category: "commercial",
        title: "Fashion Photography"
      },
      {
        id: 8,
        src: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
        alt: "Birthday Party",
        category: "events",
        title: "Birthday Party"
      },
      {
        id: 9,
        src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",
        alt: "Family Portrait",
        category: "portraits",
        title: "Family Portrait"
      }
    ]
  },

  // Featured Images for Home Page
  featuredImages: [
    {
      id: 1,
      src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",
      alt: "Portrait Photography",
      category: "Portraits"
    },
    {
      id: 2,
      src: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
      alt: "Wedding Photography",
      category: "Weddings"
    },
    {
      id: 3,
      src: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1026&q=80",
      alt: "Commercial Photography",
      category: "Commercial"
    }
  ],

  // Hero Image for Home Page
  heroImage: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",

  // About Page Image
  aboutImage: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=687&q=80",

  // Testimonials
  testimonials: [
    {
      name: "Sarah & Michael",
      type: "Wedding Clients",
      text: "Evan captured our special day perfectly. His attention to detail and artistic vision exceeded our expectations. The photos are absolutely stunning!",
      rating: 5
    },
    {
      name: "Jennifer Martinez",
      type: "Portrait Client",
      text: "Professional, creative, and incredibly talented. Evan made me feel comfortable and confident during our session. The results were amazing!",
      rating: 5
    },
    {
      name: "David Chen",
      type: "Commercial Client",
      text: "Evan's commercial photography helped elevate our brand. His work is consistently high-quality and he's a pleasure to work with.",
      rating: 5
    }
  ]
};

export default siteConfig; 